import { PHYSICAL_ACTIVITY } from "../enum";

const physicalActivityOptions = [PHYSICAL_ACTIVITY.NOT_MUCH, PHYSICAL_ACTIVITY.ONE_TWO_PER_WEEK, PHYSICAL_ACTIVITY.THREE_FIVE_PER_WEEK, PHYSICAL_ACTIVITY.SIX_SEVEN_PER_WEEK];

export default physicalActivityOptions;
